import React from "react";

import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { Button } from "../../../common/Button/Button";
import { X } from "react-feather";

import CheckboxContainer from "../../../common/CheckboxContainer/CheckboxContainer";
import Spinner from "../../../common/Spinner/Spinner";

export default function AssignExternalServicePartnerModal(props) {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent>
      <div className="p-2 modal-header-bar">
						<span>Assign External Service Partner</span>
						<button
							type="button"
							className="close"
							aria-label="Close"
							onClick={() => props.toggleModal(!props.isOpen)}
						>
							<X
								style={{ pointerEvents: "none" }}
								color="white"
							/>
						</button>
					</div>{" "}
        <div
          className={`m-3 ${props.isLoading && "set-opacity"}`}
          style={{ overflowY: "scroll", maxHeight: "400px" }}
        >
          {props.isLoading && (
            <>
              <Spinner className="center" />
            </>
          )}
          <CheckboxContainer
            toggleSelection={props.toggleServicePartner}
            checkboxItemsList={props.servicePartnerList}
          />
        </div>
        <div style={{ margin: "5px 20px" }}>
          <Button onClick={props.saveServicePartner}>Save</Button>
          <span className="ml-2 cursor-pointer" onClick={props.toggleModal}>
            Cancel
          </span>
        </div>
      </ModalContent>
    </Modal>
  );
}
